import React, { Fragment } from 'react';
import styles from './Steps.module.scss';
import { ReactComponent as ArrowDown } from 'assets/static/images/arrowDown.svg';
import { StepType } from 'utils/order';

function isStepActive (step) {
  if (!step) return false;
  const { type, time, progress } = step;
  return (time || progress === 100) && type !== StepType.cancelled;
}

export default function Steps ({ steps } = {}) {
  const { title, desc, est, icon, seq } = steps;
  const isIncludeCancelled = seq.some(item => item.type === StepType.cancelled);
  return (
    <div className={styles.stepsContainer}>
      <div className={styles.header}>
        <div className={styles.infos}>
          {est && <span className={styles.est}>{est}</span>}
          <div className={styles.title}>{title}</div>
          <div className={styles.desc}>{desc}</div>
        </div>
        {!!icon && (
          <div className={styles.infoIcon}>
            {icon()}
          </div>
        )}
      </div>
      <div className={styles.steps}>
        {seq.map((item, index) => {
          const { icon, time, progress } = item;
          const active = isStepActive(item) && !isIncludeCancelled;
          return (
            <Fragment key={index}>
              {index !== 0 && (
                <div className={styles.stepProgress}>
                  {(() => {
                    // Guard: cancel 不展示进度条
                    if (isIncludeCancelled) return;
                    // Guard: progress 不存在, 不展示进度条
                    if (typeof progress !== 'number') return;
                    // Guard: 满了, 固定进度
                    if (progress === 100 || time) {
                      return (
                        <div
                          className={styles.progress}
                          style={{ width: '100%' }}
                        />
                      );
                    }
                    //  没满, 动画进度条
                    return (
                      <div className={[styles.progress, styles.progressWithAnim].join(' ')} />
                    );
                  })()}
                </div>
              )}
              <div className={styles.stepItem}>
                <div className={styles.icon} style={{ color: active ? '#EE4D2D' : 'rgba(0,0,0,0.26)' }}>
                  {icon()}
                </div>
                {time && <div className={styles.arrow}>{<ArrowDown />}</div>}
                {time && (
                  <div
                    className={[
                      styles.tooltip,
                      index < seq?.length / 2 ? styles.tooltipLeftPad : styles.tooltipRightPad,
                    ].join(' ')}
                  >
                    {time}
                  </div>
                )}
              </div>
            </Fragment>
          );
        })}
      </div>
    </div>
  );
}
